import type { MedicationRequest } from "@curai/js-fhir-tools";

export interface Detail {
  label: string;
  value: string;
}

export const usePrescriptionInfo = (medicationRequest: MedicationRequest) => {
  const rxDetailsGroup1 = [
    {
      label: "Dispense Amount",
      value: `${medicationRequest.dispenseQuantity} ${medicationRequest.dispenseUnitDisplay}`,
    },
    {
      label: "Days Supply",
      value: medicationRequest.daysSupply,
    },
    {
      label: "Substitution Allowed",
      value: medicationRequest.substitutionAllowed ? "Allowed" : "Not Allowed",
    },
    {
      label: "Refills",
      value: medicationRequest.refills,
    },
    {
      label: "Directions for Patient",
      value: medicationRequest.sig,
    },
    {
      label: "Notes for Pharmacy",
      value: medicationRequest.noteToPharmacy,
    },
  ] as Detail[];

  const rxDetailsGroup2 = [
    {
      label: "Ordering Clinician",
      value: medicationRequest.orderingPhysician.display,
    },
    {
      label: "Written Date",
      value: medicationRequest.effectiveDate,
    },
    {
      label: "Pharmacy",
      value: [
        medicationRequest.pharmacy?.name,
        medicationRequest.pharmacyAddress?.line?.join(", "),
        `${medicationRequest.pharmacyAddress?.city} ${medicationRequest.pharmacyAddress?.state} ${medicationRequest.pharmacyAddress?.postalCode}`,
        medicationRequest.pharmacyPhone,
      ].join("\r\n"),
    },
    {
      label: "eRx Status",
      value: medicationRequest.dosespotStatusLabel,
    },
  ] as Detail[];

  const rxDetailsGroup3 = [
    {
      label: "Routing Method",
      value: medicationRequest.routingMethodLabel,
    },
    {
      label: "eRx Order ID",
      value: medicationRequest.dosespotOrderId,
    },
  ] as Detail[];

  return { rxDetailsGroup1, rxDetailsGroup2, rxDetailsGroup3 };
};
